import PwsPopupContent from './PwsPopupContent';
import React, { useCallback, useState } from 'react';
import { Modal, Button } from 'forms';
import '../../styles/pws-popup-modal.scss';
import { PopupData } from '../types';
import t from 'rcm-i18n';
import { OptionControlsPortal } from 'forms-editable';
import PortalToBody from 'react-portal-to-body';

interface Props {
    popup: PopupData;
}

const PwsPopupPreviewButton = (props: Props) => {
    const [show, setShow] = useState(false);
    const handlePreviewClick = useCallback(() => {
        setShow(true);
    }, []);
    const handleClose = useCallback(() => {
        setShow(false);
    }, []);

    return <PortalToBody>
        <Modal show={show}
            onClose={handleClose}
            className="pws-popup-modal">
            <PwsPopupContent popup={props.popup} onLinkButtonClick={() => { }} />
        </Modal>
        <OptionControlsPortal.Send>
            <Button
                btn="default"
                onClick={handlePreviewClick}
                text={t('Preview')}
            />
        </OptionControlsPortal.Send>
    </PortalToBody>;
};

export default PwsPopupPreviewButton;
